export default {
    language: {
        title: 'Język',
        description: 'W nim widzisz aplikację. Zmiana nie tłumaczy tego, co już masz zapisane.',
        saved: 'Zapisane.',
        failed: 'Nie udało się zapisać języka.',
    },
    gender: {
        label: 'Płeć',
        female: 'Kobieta',
        male: 'Mężczyzna',
    },
    currencies: {
        PLN: 'Złoty polski (zł)',
        EUR: 'Euro (€)',
        GBP: 'Funt brytyjski (£)',
        USD: 'Dolar amerykański ($)',
        CHF: 'Frank szwajcarski (CHF)',
        CZK: 'Korona czeska (Kč)',
        SEK: 'Korona szwedzka (kr)',
        NOK: 'Korona norweska (kr)',
        DKK: 'Korona duńska (kr)',
        CAD: 'Dolar kanadyjski ($)',
        AUD: 'Dolar australijski ($)',
    },
    deleteAccount: {
        title: 'Usuń konto',
        description: 'Konto i wszystkie dane znikną od razu i na zawsze.',
        open: 'Usuń konto…',
        confirmTitle: 'Usunąć konto na zawsze?',
        whatGoes: 'Usuniemy od razu konto i wszystko, co jest w nim zapisane: planer (zadania, wydarzenia, notatki, sen, treningi, wpisy dnia), posiłki i produkty, listy zakupów, finanse i Portfel, projekty, ustawienia oraz historię AI. Tego nie da się cofnąć.',
        googleNote: 'Dostęp do Google Calendar zostanie odwołany. Wydarzenia w samym Kalendarzu Google zostają.',
        confirmPassword: 'Potwierdź hasłem',
        orGoogle: 'albo zaloguj się ponownie przez Google',
        confirmGoogle: 'Potwierdź, logując się ponownie przez Google',
        wrongPassword: 'Nieprawidłowe hasło.',
        googleMismatch: 'Zaloguj się kontem Google połączonym z Rountine i spróbuj od razu ponownie.',
        failed: 'Nie udało się usunąć konta. Spróbuj ponownie albo napisz na kontakt{\'@\'}rountine.com.',
    },
    profileSetup: {
        title: 'Uzupełnij dane',
        intro: 'Konto gotowe. Kilka informacji, żeby aplikacja lepiej do Ciebie pasowała — wszystko zmienisz później w Ustawieniach.',
        genderHint: '— tak będziemy się do Ciebie zwracać',
        later: 'Później',
    },
    googleCalendar: {
        reasons: {
            denied: 'Nie udzielono zgody w Google.',
            scope: 'Bez zgody na dostęp do kalendarza synchronizacja nie zadziała — zaznacz ją przy łączeniu.',
            state: 'Link do połączenia wygasł — spróbuj jeszcze raz.',
            google: 'Google nie odpowiedział poprawnie — spróbuj jeszcze raz.',
        },
        connected: 'Połączono z kalendarzem Google.',
        connectFailed: 'Nie udało się połączyć z Google.',
        startFailed: 'Nie udało się rozpocząć łączenia z Google.',
        saveFailed: 'Nie udało się zapisać ustawień kalendarza.',
        syncFailed: 'Synchronizacja nie powiodła się.',
        synced: 'Zsynchronizowano.',
        syncedChanged: 'Zsynchronizowano — zmienione wydarzenia: {n}.',
        syncError: 'Nie udało się zsynchronizować.',
        disconnected: 'Odłączono konto Google. Wydarzenia zostały w aplikacji.',
        disconnectFailed: 'Nie udało się odłączyć konta.',
        primary: '{name} (główny)',
        notYet: 'jeszcze nie',
        unavailable: 'To API nie obsługuje jeszcze kalendarza Google.',
        connection: 'Połączenie',
        connectionNotConfiguredDescription: 'Synchronizacja wydarzeń z kalendarzem Google.',
        notConfigured: 'Synchronizacja z Google nie jest jeszcze skonfigurowana na serwerze.',
        connectionDescription: 'Wydarzenia z aplikacji mogą trafiać do Twojego kalendarza Google, a te z Google — do planera.',
        redirecting: 'Przekierowuję…',
        connect: 'Połącz z Google',
        account: 'Konto Google',
        accountDescription: 'Konto, z którego kalendarzem synchronizujemy wydarzenia.',
        reauth: 'Google cofnął dostęp aplikacji — synchronizacja stoi. Połącz konto ponownie.',
        reconnect: 'Połącz ponownie',
        disconnect: 'Odłącz konto',
        calendar: 'Kalendarz',
        calendarDescription: 'Zmiana kalendarza odłącza wydarzenia od poprzedniego (zostają w aplikacji) i pobiera nowy.',
        searchCalendar: 'Szukaj kalendarza…',
        sync: 'Synchronizacja',
        syncDescription: 'Każdy kierunek włączasz osobno.',
        export: 'Wysyłaj wydarzenia z aplikacji do Google',
        exportHint: 'Dodanie, zmiana i usunięcie wydarzenia od razu trafia do kalendarza. Po włączeniu wyślemy też wydarzenia od dziś w przód.',
        import: 'Pobieraj wydarzenia z Google do aplikacji',
        importHint: 'Co kilka minut i przy otwarciu planera. Po wyłączeniu pobrane wydarzenia zostają w aplikacji.',
        status: 'Stan',
        statusDescription: 'Synchronizacja działa sama co kilka minut.',
        lastSync: 'Ostatnia synchronizacja: {when}',
        lastError: 'Ostatni błąd: {error}',
        wait: 'Chwila…',
        syncNow: 'Synchronizuj teraz',
        disconnectTitle: 'Odłączyć konto Google?',
        disconnectMessage: 'Synchronizacja przestanie działać. Wydarzenia zostaną w aplikacji, a w Google nic nie zostanie usunięte.',
        disconnectConfirm: 'Odłącz',
    },
    restoreDefaults: 'Przywróć domyślne',
    tiles: {
        saveFailed: 'Nie udało się zapisać kafli.',
        onScreen: 'Na ekranie · {count} z {max} — pierwszy kafel jest wyróżniony.',
        up: 'Wyżej: {name}',
        down: 'Niżej: {name}',
        remove: 'Usuń z ekranu: {name}',
        available: 'Do wyboru',
        max: 'Najwyżej {max} kafli — usuń któryś, żeby dodać ten',
        add: 'Dodaj: {name}',
    },
    profile: {
        account: 'Konto',
        accountDescription: 'Adres, na który się logujesz.',
        logout: 'Wyloguj się',
        googleTitle: 'Logowanie przez Google',
        googleDescription: 'Wchodź na konto kontem Google zamiast hasłem. Może to być konto Google z innym adresem niż powyższy.',
        googleConnectedAs: 'Połączone: {email}',
        googleDisconnect: 'Odłącz',
        noPassword: 'To konto nie ma hasła — Google jest jedynym sposobem logowania. Żeby odłączyć Google, {link}.',
        setPasswordFirst: 'najpierw ustaw hasło',
        googleConnected: 'Konto Google połączone — możesz się nim logować.',
        googleTaken: 'To konto Google jest już połączone z innym kontem w Rountine.',
        googleConnectFailed: 'Nie udało się połączyć konta Google.',
        googleDisconnected: 'Konto Google odłączone.',
        googleDisconnectFailed: 'Nie udało się odłączyć konta Google.',
        genderDescription: 'Tak aplikacja się do Ciebie zwraca, np. „Jak spałeś?” albo „Jak spałaś?”.',
        genderFailed: 'Nie udało się zapisać płci.',
        // „Asystent i Ty”: imię asystenta, jego głos i imię użytkownika
        assistant: 'Asystent i Ty',
        assistantDescription: 'Jak nazywa się Twój asystent, jakim mówi głosem i jak ma się do Ciebie zwracać.',
        assistantName: 'Imię asystenta',
        assistantNamePlaceholder: 'Asystent',
        userName: 'Jak się do Ciebie zwracać',
        userNamePlaceholder: 'np. Paweł',
        userNameHint: 'Asystent będzie zwracał się do Ciebie po imieniu — z umiarem',
        namesFailed: 'Nie udało się zapisać imion.',
        currency: 'Waluta',
        currencyDescription: 'Wszystkie kwoty — w Portfelu, Finansach, cenach jedzenia i zakupów. Zmiana niczego nie przelicza, zmienia tylko zapis kwot.',
        currencyFailed: 'Nie udało się zapisać waluty.',
        body: 'Ciało',
        bodyDescription: 'Waga i wzrost — do przeliczeń w planerze.',
        weight: 'Waga',
        height: 'Wzrost',
        saveFailed: 'Nie udało się zapisać profilu.',
    },
    app: {
        mode: 'Tryb uruchomienia',
        modeDescription: 'Jak działa Rountine na tym urządzeniu.',
        standalone: 'Zainstalowana aplikacja z ekranu telefonu.',
        browserTab: 'Karta przeglądarki. Szybki wybór i skróty na ikonie działają dopiero w aplikacji zainstalowanej z menu przeglądarki („Zainstaluj aplikację”).',
        phoneDescription: 'Dodaj Rountine do ekranu telefonu — otwiera się jak aplikacja, bez paska przeglądarki.',
        android: 'otwórz app.rountine.com w Chrome, menu ⋮ → „Zainstaluj aplikację” (albo „Dodaj do ekranu głównego”).',
        iphone: 'otwórz app.rountine.com w Safari, „Udostępnij” → „Do ekranu początkowego”.',
        googlePlay: 'Aplikacja na Androida jest w drodze do Google Play.',
        phoneDone: 'Rountine jest już na Twoim telefonie.',
        markPhone: 'Mam już na telefonie',
        launcherDescription: 'Kafelki z najczęstszymi miejscami zamiast rozmowy z asystentem — po uruchomieniu i po powrocie po co najmniej 15 minutach.',
        launcher: 'Po otwarciu pokazuj szybki wybór',
        preview: 'Podgląd',
        tiles: 'Kafle szybkiego wyboru',
        tilesDescription: 'Które miejsca są na ekranie szybkiego wyboru i w jakiej kolejności. Zapisują się na koncie — te same na każdym urządzeniu.',
        voice: 'Głos asystenta',
        voiceDescription: 'Czy asystent czyta odpowiedzi na głos na tym urządzeniu.',
        voiceModes: {
            spoken: 'Gdy do niego mówię',
            always: 'Zawsze',
            never: 'Nigdy',
        },
        voiceKind: 'Jaki głos',
        voices: {
            female: 'Damski',
            male: 'Męski',
        },
        voiceListen: 'Posłuchaj',
        voiceSample: {
            female: 'Cześć! Zapisałam: Biedronka, sto złotych. Masz paragon?',
            male: 'Cześć! Zapisałem: Biedronka, sto złotych. Masz paragon?',
        },
        hints: 'Objaśnienia',
        hintsDescription: 'Pigułki „Co to?” przy sekcjach we wszystkich modułach. Przewodnik pod „Pomoc” działa i bez nich.',
        hintsToggle: 'Pokazuj objaśnienia „Co to?”',
    },
    wholeAccount: 'dla całego konta',
    menu: {
        saveFailed: 'Nie udało się zapisać menu.',
        pinned: 'Przypięte w menu',
        pinnedDescription: 'Stoją w szynie na komputerze pod Asystentem i Planerem, a pierwsze dwa także w dolnym pasku telefonu. Przypinasz pinezką na kaflu w panelu „Wszystko”.',
        pinnedEmpty: 'Nic nie jest przypięte — wszystkie moduły są pod „Wszystko”.',
        onPhone: 'też na telefonie',
        unpin: 'Odepnij „{name}”',
        openAll: 'Otwórz panel „Wszystko”',
        resetPins: 'Przywróć domyślne przypięte',
        modules: 'Moduły',
        modulesDescription: 'Schowaj to, czego nie używasz, i ustaw kolejność w grupie. Schowany moduł nadal znajdziesz wyszukiwarką (⌘K / Ctrl+K).',
        alwaysVisible: 'strona główna — zawsze widoczna',
        moveUp: 'Przesuń „{name}” wyżej',
        moveDown: 'Przesuń „{name}” niżej',
        reset: 'Przywróć domyślne menu',
        beta: 'Nowe wersje modułów',
        betaDescription: 'Portfel powstaje obok Finansów — ma własne dane i może się jeszcze zmieniać.',
        betaToggle: 'Pokaż nowe wersje modułów — w menu, wyszukiwarce i kaflach szybkiego wyboru',
    },
    topBar: {
        saveFailed: 'Nie udało się zapisać układu paska.',
        buttons: 'Przyciski',
        buttonsDescription: 'Włącz to, czego używasz, i ustaw kolejność od lewej do prawej. Ten sam układ widać na telefonie i komputerze.',
        empty: 'Pusty pasek',
        earlierTitle: 'Wcześniej — bardziej w lewo',
        earlier: 'Przesuń „{name}” wcześniej',
        laterTitle: 'Dalej — bardziej w prawo',
        later: 'Przesuń „{name}” dalej',
        searchHint: 'Wyszukiwarka działa też bez przycisku: ⌘K / Ctrl+K.',
        reset: 'Przywróć domyślny układ',
    },
    goals: {
        fields: {
            calories: 'Kalorie',
            protein: 'Białko',
            carbs: 'Węglowodany',
            fat: 'Tłuszcz',
            fiber: 'Błonnik',
            sugar: 'Cukier',
            saturated_fat: 'Tłuszcze nasycone',
            salt: 'Sól',
        },
        lists: {
            allergies: { label: 'Alergie i nietolerancje', placeholder: 'np. orzechy, laktoza', hint: 'AI nigdy ich nie użyje.' },
            avoid: { label: 'Nie jem', placeholder: 'np. wątróbka, koper' },
            likes: { label: 'Lubię', placeholder: 'np. kuchnia azjatycka, kasze' },
            equipment: { label: 'Sprzęt w kuchni', placeholder: 'np. piekarnik, blender, air fryer' },
        },
        activity: {
            low: { label: 'Siedzący', hint: 'praca przy biurku, bez treningów' },
            light: { label: 'Lekki', hint: 'spacery, 1–2 treningi w tygodniu' },
            moderate: { label: 'Średni', hint: '3–4 treningi w tygodniu' },
            high: { label: 'Wysoki', hint: 'trening prawie codziennie' },
            very_high: { label: 'Bardzo wysoki', hint: 'praca fizyczna i treningi' },
        },
        aims: {
            cut: 'Schudnąć',
            keep: 'Utrzymać wagę',
            gain: 'Przytyć / masa',
        },
        missing: {
            sex: 'płeć',
            birth_year: 'rok urodzenia',
            height: 'wzrost',
            weight: 'wagę',
            activity: 'aktywność',
            aim: 'cel',
        },
        missingPrompt: 'Podaj {fields}.',
        calcFailed: 'Nie udało się wyliczyć.',
        saveFailed: 'Nie udało się zapisać.',
        daily: 'Cele dzienne',
        dailyDescription: 'Jedne dla całej aplikacji: bilans w Jedzeniu, paski w Planerze, propozycje AI. Puste pole = bez celu.',
        calculated: 'Wyliczone — sprawdź wartości poniżej i zapisz.',
        calcPrompt: 'Nie wiesz, ile? Wyliczę z Twoich danych.',
        calcOpen: 'Wylicz za mnie',
        calc: 'Wylicz',
        birthYear: 'Rok urodzenia',
        aim: 'Cel',
        activityLabel: 'Aktywność',
        prefs: 'Preferencje żywieniowe',
        prefsDescription: 'Ustawiasz raz — biorą je pod uwagę wszystkie propozycje AI: przepisy w rozmowie, układanie dni, analiza posiłku i szybki wpis.',
        removeItem: 'Usuń: {item}',
        cookingTime: 'Zwykle mam na gotowanie',
    },
    ai: {
        features: {
            entry_split: 'Nagrywanie — podział na wpisy',
            task_extraction: 'Nagrywanie — zadanie',
            event_extraction: 'Nagrywanie — wydarzenie',
            sleep_extraction: 'Nagrywanie — sen',
            meal_extraction: 'Nagrywanie — posiłek',
            training_extraction: 'Nagrywanie — trening',
            transcription: 'Rozpoznawanie mowy',
            shopping_dictation: 'Dyktowanie zakupów',
            recipe_import: 'Import przepisu',
            receipt_analysis: 'Paragon ze zdjęcia',
            product_macros: 'Makra produktu z AI',
            note_extraction: 'Nagrywanie — notatka',
            meal_analysis: 'Analiza posiłku',
        },
        month: 'Miesiąc',
        limitTitle: 'Limit AI',
        limitUsed: 'Wykorzystano {n}% miesięcznego limitu AI',
        limitRenews: 'odnowi się {date}',
        limitReached: 'Limit wyczerpany — funkcje AI wrócą po odnowieniu.',
        cost: 'Koszt',
        calls: 'Wywołania',
        errors: '{n} błąd | {n} błędy | {n} błędów',
        input: 'Wejście',
        inputTokens: 'tokenów, w tym z cache {n}',
        output: 'Wyjście',
        outputTokens: 'tokenów, w tym „myślenie” {n}',
        avgTime: 'Średni czas',
        allTime: 'Od początku: {calls} wywołanie, {cost}. Ceny w USD według cennika OpenAI z chwili wywołania. | Od początku: {calls} wywołania, {cost}. Ceny w USD według cennika OpenAI z chwili wywołania. | Od początku: {calls} wywołań, {cost}. Ceny w USD według cennika OpenAI z chwili wywołania.',
        none: 'W tym miesiącu nie było wywołań AI.',
        byFeature: 'Według funkcji',
        byModel: 'Według modelu',
        latest: '— ostatnie {n}',
        inputDetail: '{tokens} (cache {cached})',
        outputDetail: '{tokens} („myślenie” {reasoning})',
        recording: 'Nagranie',
        error: 'Błąd: {error}',
        contentFailed: 'Nie udało się pobrać treści.',
        inputSent: 'Wejście (wysłane)',
        outputReceived: 'Wyjście (odpowiedź)',
        copy: 'Kopiuj',
    },
};
